import {createAction} from '@reduxjs/toolkit';

import type {ClientThread} from '../types/extended';

export const receivedThreads = createAction<ClientThread[]>('threads/actions/receivedThreads');
